import React from 'react'
import PropTypes from 'prop-types'
import MinicartIcon from 'hec/assets/minicart'
import {FormattedNumber} from 'react-intl'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks/use-currency'
import {cn} from '@/lib/utils'

const MinicartTotal = ({active, basket, totalItems, adjustedOrderTotal}) => {
    const siteCurrency = useCurrency()

    return (
        <div className="inline-flex items-end h-[2.8125rem] relative">
            <div
                className={cn(
                    'hidden absolute top-full left-[calc(50%_-_1.625rem)]',
                    'border-b-[0.3125rem] border-b-accent border-solid',
                    'border-l-[0.3125rem] border-l-transparent',
                    'border-r-[0.3125rem] border-r-transparent',
                    active && 'block'
                )}
            ></div>
            <div className="min-w-[2.3125rem]">
                <div className="relative inline-block">
                    <MinicartIcon
                        className="text-accent"
                        data-testid="minicartTotal-MinicartIcon"
                    />
                    <span className="absolute -top-1 -right-1 translate-x-2/4 -translate-y-2/4 block w-[1.125rem] h-[1.125rem] rounded-full bg-accent text-accent-foreground font-[helveticaneue,sans-serif] text-[0.6875rem]/[1.125rem] font-medium text-center">
                        {totalItems || 0}
                    </span>
                </div>
                <span className="hidden lg:inline text-accent ml-[1.125rem] font-grotesque text-[0.75rem] leading-none">
                    <FormattedNumber
                        style="currency"
                        currency={basket?.currency || siteCurrency.currency}
                        value={adjustedOrderTotal ?? basket?.orderTotal ?? 0}
                        data-testid="minicartTotal-FormattedNumber"
                    />
                </span>
            </div>
        </div>
    )
}

MinicartTotal.propTypes = {
    active: PropTypes.bool.isRequired,
    basket: PropTypes.object,
    totalItems: PropTypes.number,
    adjustedOrderTotal: PropTypes.number
}

export default MinicartTotal
